module.exports = __webpack_public_path__ + "static/media/008-certification.eb595192.svg";